import React, { useEffect, useRef } from 'react';
import { Modal as AntdModal } from 'antd';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { CloseIcon } from '../icons/CloseIcon';
import { Button } from './Button';
import { Flex } from './Flex';
import { Title } from './Text';

const StyledModalMask = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(198,211,232,.75);
    z-index: 1000;
`;

const StyledModalWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

const StyledModal = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 600px;
    min-height: 80px;
    background: white;
    border-radius: 16px;
    box-shadow: 0px 2px 4px 0px rgba(18, 46, 103, 0.10);
    padding: 18px 24px 20px;
`;

const CloseFormButton = styled.span`
    position: absolute;
    top: 16px;
    right: 16px;
`;

const confirmModalOptions = ({
    centered: true,
    icon: null,
    className: 'sp-confirm-modal',
    title: <Title h4 color="#E8AF1D">Attention!</Title>,
    okText: "Delete",
    okButtonProps: { style: { background: "#e96666", borderRadius: "4px", border: "none", fontWeight: "600" } },
    cancelButtonProps: { type: "link", style: { fontWeight: "600", fontSize: "14px", color: "#1d65db" } },
    onCancel() { },
});

const Modal = ({ visible, onCancel, onOk, ...props}) => {
    const ref = useRef();
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                onCancel();
            }
        }
        if (visible) {
            document.addEventListener("mousedown", handleOutsideClick, false);
        };

        return () => document.removeEventListener("mousedown", handleOutsideClick, false);
    }, [ visible, onCancel ]);

    return (visible
        ? <>
            {createPortal(
                <div>
                    <StyledModalMask />
                    <StyledModalWrapper>
                        <StyledModal id="sp-modal" visible={visible} ref={ref} {...props}>
                            <CloseFormButton onClick={() => onCancel()}>
                                <CloseIcon />
                            </CloseFormButton>
                            {props.children}
                            {typeof onOk === "function"
                                ? <Flex margin={{ top: "18px" }} gap={{ right: 8 }} justify="flex-end">
                                    <Button link onClick={() => onCancel()}>Cancel</Button>
                                    <Button onClick={() => onOk()}>Ok</Button>
                                </Flex>
                                : null}
                        </StyledModal>
                    </StyledModalWrapper>
                </div>
            , document.getElementById("root"))}
        </>
        : null
    )
};

Modal.confirm = (props) => AntdModal.confirm({ ...confirmModalOptions, ...props });

export { Modal };
